import { render } from "./DisplayPhoto.vue?vue&type=template&id=4b7b3059&scoped=true&ts=true"
import script from "./DisplayPhoto.vue?vue&type=script&lang=ts"
export * from "./DisplayPhoto.vue?vue&type=script&lang=ts"

import "./DisplayPhoto.vue?vue&type=style&index=0&id=4b7b3059&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7b3059"]])

export default __exports__